<div class="col-auto mr-auto ml-2 medium pt-5 text-muted">
    <ng-content></ng-content>
</div>

